import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

const links = [
  { href: '#about', label: 'Обо мне' },
  { href: '#services', label: 'Направления' },
  { href: '#how', label: 'Как это работает' },
  { href: '#pricing', label: 'Стоимость' },
  { href: '#contact', label: 'Контакты' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navClass = scrolled
    ? 'bg-cream/95 backdrop-blur-sm border-b border-ink/10'
    : 'bg-transparent';

  return (
    <header
      className={`fixed left-0 right-0 z-40 transition-all duration-300 ${navClass}`}
      style={{ top: 'var(--nav-offset, 0px)' }}
      data-testid="navbar"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 h-14 md:h-16 flex items-center justify-between">
        <a href="#top" className="font-heading text-lg md:text-xl text-ink tracking-wide" data-testid="nav-logo">
          Светлана Белавская
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[14px] text-ink/75 hover:text-wine transition-colors duration-200"
              data-testid={`nav-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className="ml-2 px-5 py-2 text-[14px] border border-ink text-ink hover:bg-wine hover:text-cream hover:border-wine transition-colors duration-300"
            data-testid="nav-cta-record"
          >
            Записаться
          </a>
        </nav>

        <button
          aria-label="Меню"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 -mr-2 text-ink"
          data-testid="nav-burger"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <div
        className={`md:hidden fixed top-14 right-0 bottom-0 w-72 bg-cream border-l border-ink/10 transform transition-transform duration-300 ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
        data-testid="nav-mobile-panel"
      >
        <div className="flex flex-col gap-2 p-6 pt-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="min-h-[44px] flex items-center text-lg text-ink hover:text-wine transition-colors"
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-4 text-center min-h-[48px] flex items-center justify-center border border-ink text-ink hover:bg-wine hover:text-cream hover:border-wine transition-colors duration-300"
            data-testid="nav-mobile-cta"
          >
            Записаться
          </a>
        </div>
      </div>
    </header>
  );
}
